export enum MessageType {
  QUESTION = 'question',
  ANSWER = 'answer'
}
export interface Message {
  type: MessageType
  text: string
}
